<template>
  <div class="columns is-centered">
    <div class="column is-half">
      <b-field label="Project">
        <b-input v-model="projectName" placeholder="Visual case study GOOG"></b-input>
      </b-field>
      <b-field label="Description">
        <b-input v-model="projectDescription" maxlength="200" type="textarea" placeholder="Our project with Google..."></b-input>
      </b-field>
      <b-field>
        <p class="control">
          <button @click="storeValues" class="button is-primary">Send Project</button>
        </p>
      </b-field>
      <b-field>
        <p class="control">
          <button @click="navigateBack" class="button is-warning">Go Back</button>
        </p>
      </b-field>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormTwo',
  data: function() {
    return {
      projectName: "",
      projectDescription: ""
    }
  },
  methods: {
    storeValues: function() {
      this.$store.commit("setProject", {projectName: this.projectName, description: this.projectDescription});
      this.$buefy.toast.open({
        message: 'Project saved!',
        type: 'is-success',
        position: "is-top"
      })
      this.projectName = "";
      this.projectDescription = "";
    }
  }
}
</script>

<style scoped>
.second-b {
  margin-left: 10px;
}
</style>
